const EventService = {
  emitCustomEvent: (name) => {
    if (typeof window.CustomEvent === "function") {
      document.body.dispatchEvent(new CustomEvent(name));
    }
  },
};

export default EventService;
